import { Modal } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import usePrevious from 'commons/hooks/usePrevious';
import { MEETING_TYPES } from 'commons/types/meetingsTypes';
import DeletedMeeting from './DeletedMeeting';
import DeletedMeetingFail from './DeletedMeetingFail';
import UpdatedMeeting from './UpdatedMeeting';
import VerifyMeeting from './VerifyMeeting';
import ErrorScheduling from './ErrorScheduling';

const modalDict: { [key: string]: JSX.Element } = {
  to_justify_RDV_1: <VerifyMeeting type={MEETING_TYPES.RDV_1} />,
  to_justify_RDV_2: <VerifyMeeting type={MEETING_TYPES.RDV_2} />,
  to_justify_RDV_3: <VerifyMeeting type={MEETING_TYPES.RDV_3} />,
  to_justify_rdv_PPC: <VerifyMeeting type={MEETING_TYPES.RDV_PPC} />,
  to_justify_rdv_SWITCH: <VerifyMeeting type={MEETING_TYPES.RDV_SWITCH} />,
  error_scheduling: <ErrorScheduling />,
  updated: <UpdatedMeeting />,
  deletedMeeting: <DeletedMeeting />,
  deletedMeetingFail: <DeletedMeetingFail />,
};

export default function ModalCatcher() {
  const [searchParams] = useSearchParams();
  const state = searchParams.get('state') || '';
  const previousState = usePrevious(state);
  const knowState = Object.keys(modalDict).includes(state);
  const [open, setOpen] = useState(knowState);
  const hideModal = useCallback(() => {
    setOpen(false);
  }, []);
  useEffect(() => {
    if (state !== previousState) {
      setOpen(true);
    }
  }, [previousState, searchParams, state]);

  if (Object.keys(modalDict).includes(state)) {
    return (
      <Modal
        open={open}
        footer={null}
        closable={false}
        onOk={hideModal}
        onCancel={hideModal}
      >
        {modalDict[state]}
      </Modal>
    );
  }
  return null;
}
